exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-highlight[data-v-36d1e83a]{border:1px solid #ccc;border-radius:5px;box-shadow:0 0 10px rgba(0,0,0,.1)}", ""]);

// exports
